import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { UserIdentity } from "../../core";

const SessionContext = createContext<UserIdentity | null>(null);

export function SessionProvider({ value, children }: { value: UserIdentity; children: ReactNode }) {
    return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession(): UserIdentity {
    const ctx = useContext(SessionContext);
    if (!ctx) throw new Error("useSession must be used within a SessionProvider");
    return ctx;
}
